import { Configuration, PublicClientApplication } from "@azure/msal-browser";

export const basePath = import.meta.env.VITE_BASE_PATH || "/";

const msalConfig: Configuration = {
  auth: {
    clientId: import.meta.env.VITE_AZURE_APPLICATION_ID ?? "",
    authority: import.meta.env.VITE_AZURE_AUTHORITY_URL,
    redirectUri: document.location.origin,
    postLogoutRedirectUri: document.location.origin,
  },
  cache: {
    // storeAuthStateInCookie: false,
    cacheLocation: "localStorage",
  },
};

export const msalInstance = new PublicClientApplication(msalConfig);

export const apiAccessRequest = {
  scopes: import.meta.env.VITE_AZURE_ACCESS_TOKEN_CLAIMS_API?.split(",") || [],
};

export const returnPathKey = "trackwise.returnPath";

type Navigate = (url: string) => void;

const defaultNavigate: Navigate = (url) => {
  window.location.href = url;
};

let redirecting = false;

export const redirectToLogin = async (navigate: Navigate = defaultNavigate) => {
  if (redirecting) return;
  redirecting = true;

  if (sessionStorage.getItem(returnPathKey) === null) {
    sessionStorage.setItem(
      returnPathKey,
      window.location.pathname + window.location.search,
    );
  }

  await msalInstance.clearCache();
  navigate(basePath + "login");
};

export const consumeReturnPath = (): string | null => {
  const path = sessionStorage.getItem(returnPathKey);
  if (path !== null) sessionStorage.removeItem(returnPathKey);
  return path;
};

export const resetRedirectGuard = () => {
  redirecting = false;
};

export const acquireAccessToken = async () => {
  const activeAccount = msalInstance.getActiveAccount();
  const accounts = msalInstance.getAllAccounts();

  if (!activeAccount && accounts.length === 0) {
    throw new Error("Tried to acquire token before logging in");
  }

  const accessTokenRequest = {
    scopes: apiAccessRequest.scopes,
    account: activeAccount || accounts[0],
    redirectUri: window.location.origin + basePath + "blank.html",
  };

  try {
    const token = await msalInstance.acquireTokenSilent(accessTokenRequest);
    return token.accessToken;
  } catch {
    console.warn("Session expired, redirecting to login");
    await redirectToLogin();
  }
};
